import { useContext } from 'react';
import * as R from 'ramda';

import LocationsAndAssetsContext from '@atom/components/common/workOrderDetail/locationsAndAssetsSection/LocationsAndAssetsContext';
import { Icon } from '@atom/mui';
import { ErrorOutlineIcon } from '@atom/mui/icons';
import colors from '@atom/styles/colors';

import {
  AddAssetError,
  getCrossValidationAttributes,
} from '../taskLocationUtilities';

import classes from './taskAssetModal.module.css';

interface Props {
  assetErrorType: AddAssetError;
}

const AldotAssetError = ({ assetErrorType }: Props) => {
  const { locations, assets: assetsOnTask } = useContext(
    LocationsAndAssetsContext,
  );

  const crossAttributes = getCrossValidationAttributes(assetsOnTask, locations);

  const content =
    assetErrorType === AddAssetError.ALDOT_CART
      ? 'Management Unit, County, and Road Class for assets must remain the same on the task.'
      : 'All locations and assets added after must have the same management unit, county, road class.';

  const showAdditionalInfo = assetErrorType === AddAssetError.ALDOT_CROSS;

  return (
    <div className={classes.errorContainer}>
      <Icon color={colors.brand.red} icon={ErrorOutlineIcon} />
      <div className={classes.contentContainer}>
        <div>{content}</div>
        {showAdditionalInfo && (
          <div className={classes.additionalInfo}>
            {R.keys(crossAttributes).map(title => (
              <div key={title}>{`- ${title}: ${crossAttributes[title]}`}</div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AldotAssetError;
